import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { environment } from '@environments/environment';

/**
 * HTTP interceptor that prepends the API base URL to relative URLs.
 * Only modifies requests that start with '/api'.
 */
export const apiUrlInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn) => {
  if (request.url.startsWith('/api')) {
    const clonedRequest = request.clone({
      url: `${environment.apiUrl}${request.url}`,
    });
    return next(clonedRequest);
  }

  return next(request);
};
